import { render, staticRenderFns } from "./UserDashboardProjects.vue?vue&type=template&id=0b04cf83&scoped=true&"
import script from "./UserDashboardProjects.vue?vue&type=script&lang=js&"
export * from "./UserDashboardProjects.vue?vue&type=script&lang=js&"
import style0 from "./UserDashboardProjects.vue?vue&type=style&index=0&id=0b04cf83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b04cf83",
  null
  
)

export default component.exports